import { isNullOrUndefined } from ".";

export function toUsDollar(value: number, centsPrecision: number = 2): string {
    const intPart = Math.floor(value).toLocaleString('en-US');
    const decPart = value.toFixed(centsPrecision).slice(-centsPrecision);

    return `$${intPart}.${decPart}`;
}

function numberOrSomeDefault<TDefault>(value: string | null | undefined, defaultValue: TDefault): number | TDefault {
    if(isNullOrUndefined(value)) { return defaultValue; }
    var n = parseFloat(value!);
    return isNaN(n) ? defaultValue : n;
}
export function numberOrDefault(value: string | null | undefined): number {
    return numberOrSomeDefault(value, 0);
}
export function numberOrNull(value: string | null | undefined): number | null {
    return numberOrSomeDefault(value, null);
}
export function numberOrUndefined(value: string | null | undefined): number | undefined {
    return numberOrSomeDefault(value, undefined);
}